<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">最新上架</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-4" v-for="(item, index) in recentData" :key="`recentData-${index}`">
              <div
                class="flex-column btn btn-border-green font-weight-bold m-0 mb-4-5 w-100 d-flex align-items-center align-self-center justify-content-center"
                style="height:85px"
                @click="jump(item.category, item.cate_serno)"
              >
                <div class="w-100">{{ item.category_name }}</div>
                <div
                  class="w-100 font-size-13 font-weight-normal mb-1"
                >{{ item.cust_list ? item.cust_list + '...' : ''}}</div>
                <div class="w-100 font-size-13 font-weight-normal">({{ item.cust_count || '0' }}人)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setListAreaLog } from "@/service";

export default {
  name: "RecentOnlineModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    recentData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["GetCategoryStatus"])
  },
  methods: {
    ...mapActions(["setListAreaSerNo"]),
    jump(tabName, serNo) {
      // 導頁至該專區
      let linkArea = "";
      let status = this.GetCategoryStatus[serNo];
      if (tabName === "商品行銷") {
        linkArea = "precision-marketing";
      } else if (tabName === "服務/權益") {
        linkArea = "service-right";
      } else if (tabName === "整合行銷") {
        linkArea = "integrated-marketing";
      } else if (tabName === "活動推廣") {
        linkArea = "group-related";
      } else if (tabName === "法令專區") {
        linkArea = "decree-zone";
      }
      this.setListAreaSerNo(serNo); //  更新流水編到 Vuex
      this.$store.state.initCategoryStatus = status; //記錄點選的名單類別
      this.$router.push(`/list-area/${linkArea}?path=${status}`);
      this.setLog(serNo); //新增名單專區log
    },
    setLog(serNo) {
      setListAreaLog(this.$store.state.userInfo.id, serNo, "1").then(result => {
        this.listAreaLoading = false;
        if (result.header && result.header.status == "200") {
          console.log("新增成功");
        } else {
          console.error("新增名單專區log API 錯誤");
        }
      });
    }
  }
};
</script>
